import { render, staticRenderFns } from "./ListSetting.vue?vue&type=template&id=6f9865ff&scoped=true&"
import script from "./ListSetting.vue?vue&type=script&lang=js&"
export * from "./ListSetting.vue?vue&type=script&lang=js&"
import style0 from "./ListSetting.vue?vue&type=style&index=0&id=6f9865ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9865ff",
  null
  
)

export default component.exports